<template>
    <Link
        :label="label"
        :href="url"
        :iconBefore="iconBefore"
        :iconAfter="iconAfter"
        :bgColor="bgColor"
        :type="type"
    ></Link>
</template>

<script>
import Link from 'templates/objects/Link';

export default {
    name: 'block-button',
    components: {
        Link,
    },
    props: {
        label: {
            type: String,
        },
        url: {
            type: String,
        },
        iconBefore: {
            type: String,
        },
        iconAfter: {
            type: String,
        },
        type: {
            type: String,
        },
        bgColor: {
            type: Object,
        },
    },
};
</script>
